// import useLogin from "../hooks/useLogin";
// export default function Login() {
//   const {
//     email,
//     setEmail,
//     handleSubmit,
//     isValid,
//     Button,
//     Input,
//     loading,
//   } = useLogin();
//  if (loading || !Button || !Input) {
//   return <div>Loading...</div>;
// }
//   return (
//     <div className="w-full max-w-[280px] md:max-w-[511px] mx-auto min-h-[30vh] flex flex-col justify-between">
//       <h2 className="text-center text-[18px] md:hidden font-medium mb-6">
//         Login
//       </h2>
//       <Input
//         token="my-secret-token"
//         value={email}
//         onChange={setEmail}
//         placeholder="Enter your Email ID"
//         showStar={false}
//         className="w-full h-[45px] md:h-[51px] rounded-xl border px-4 text-[12px] md:text-[16px]"
//       />
//       <Button
//         token="my-secret-token"
//         onClick={handleSubmit}
//         disabled={!isValid}
//         className={`mt-20 w-full h-[45px] md:h-[51px] rounded-xl font-bold font-montserrat ${
//           isValid
//             ? "bg-[#CF0018] text-white"
//             : "bg-gray-300 text-[#827C7C]"
//         }`}
//       >
//         Submit
//       </Button>
//     </div>
//   );
// }








import useLogin from "../hooks/useLogin";

export default function Login() {
  const {
    email,
    setEmail,
    handleSubmit,
    isValid,
    Button,
    Input,
    loading,
    submitting,
  } = useLogin();
console.log(
  "LOGIN TOKEN =",
  sessionStorage.getItem("AUTH_TOKEN")
);
  const authToken =
    sessionStorage.getItem("AUTH_TOKEN") || "";
console.log("Login render", { authToken, email, isValid, loading, submitting });
  if (loading || !Button || !Input) {
    return (
      <div className="flex items-center justify-center w-full h-screen">
        <div className="w-10 h-10 border-4 border-gray-300 rounded-full border-t-red-600 animate-spin" />
      </div>
    );
  }

  return (
    <div className="w-full max-w-[280px] md:max-w-[511px] mx-auto min-h-[30vh] flex flex-col justify-between">
      <h2 className="text-center text-[18px] md:hidden font-medium mb-6">
        Login
      </h2>

      <Input
        token={authToken}
        value={email}
        onChange={setEmail}
        placeholder="Enter your Email IDSS"
        showStar={false}
        className="w-full h-[45px] md:h-[51px] rounded-xl border px-4 text-[12px] md:text-[16px]"
      />

      <Button
        token={authToken}
        onClick={handleSubmit}
        disabled={!isValid || submitting}
        className={`mt-20 w-full h-[45px] md:h-[51px] rounded-xl font-bold font-montserrat ${
          isValid && !submitting
            ? "bg-[#CF0018] text-white"
            : "bg-gray-300 text-[#827C7C]"
        }`}
      >
        {submitting ? "Loading..." : "Submit"}
      </Button>
    </div>
  );
}